"use client";
import { usePathname } from "next/navigation";
import dynamic from "next/dynamic";
import UserLayout from "../../layouts/user-layout";
import AuthModalWrapper from "@/wrappers/auth-modal-wrapper";
import { useAuthContext } from "@/context/auth/useAuthContext";
import { useEffect, useState } from "react";
import { BASE_URL } from "../../../config";
import { SocketProvider } from "@/context/socket-context/SocketContext";


// 어드민 껍데기는 주소가 /admin 일 때만 쓴다 — 그때 받아 온다.
// 예전에는 맨 위 import 라 **모든 손님이 어드민 화면 코드를 먼저 받았다.**
const AdminLayout = dynamic(() => import("../../layouts/admin-layout"), {
  ssr: false,
});

let socket;

const LayoutProvider = ({ children }) => {
  const pathname = usePathname();

  const { user, dispatch } = useAuthContext();
  const [socketInstance, setSocketInstance] = useState(null);

  useEffect(() => {
    if (user && user?.userId) {
      // 실시간 연결(socket.io, 282KB)은 **로그인한 사람에게만** 필요하다.
      // 예전에는 맨 위 import 라 비로그인 손님도 파일을 받았다 — 이제 여기서 받아 온다.
      let cancelled = false;
      let cleanup = () => {};
      import("socket.io-client").then(({ default: io }) => {
        if (cancelled) return;
        socket = io(BASE_URL);
        setSocketInstance(socket);

        // Register the userId (replace with actual userId)
        const userId = user.userId;
        socket.emit("register", userId);

        socket?.on("inc unread msg", () => {
          dispatch({
            type: "INC_UNREAD_MESSAGES",
            payload: 1,
          });
        })

        socket?.on("dec unread msg", ({ previousUnreadCount }) => {
          const unread = previousUnreadCount || 0;
          dispatch({
            type: "DEC_UNREAD_MESSAGES",
            payload: unread,
          });
        })

        cleanup = () => {
          socket?.off("inc unread msg");
          socket?.off("dec unread msg");
          socket?.disconnect(); // Clean up connection on component unmount
        };
      });

      return () => {
        cancelled = true;
        cleanup();
      };
    }
  }, [user]);

  // 크리에이터 화면도 앱 껍데기를 쓴다.
  //
  // 예전에는 /creator 전체가 별도 껍데기(파란 강조·다른 하단탭·회색 배경) 안에 있어
  // 들어가는 순간 다른 앱처럼 보였다. 2026-07-31 에 올리기 화면만 앱 안으로
  // 들여왔는데, 나머지(콘텐츠 관리·계정 개요·프로필 설정)도 같은 문제라 함께 옮긴다
  // (2026-08-02 검수 2-A).

  if (pathname.startsWith("/admin")) {
    return (
      <SocketProvider socket={socketInstance}>
        <AuthModalWrapper>
          <AdminLayout>{children}</AdminLayout>
        </AuthModalWrapper>
      </SocketProvider>
    );
  }

  return (
    <SocketProvider socket={socketInstance}>
      <AuthModalWrapper>
        <UserLayout>{children}</UserLayout>
      </AuthModalWrapper>
    </SocketProvider>
  );
};

export default LayoutProvider;
